var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_11491)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 29.7671,
    fill: "#FCF2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9148 11.0737C50.7465 -3.69093 25.2563 -3.69168 11.0886 11.0741C-3.23356 24.8306 -3.72716 49.3447 9.95436 63.7134C10.3708 64.1672 11.0761 64.1972 11.5299 63.7811C11.9836 63.3646 12.0138 62.6593 11.5975 62.2056C-9.39718 39.4091 6.9993 2.07588 38.0021 2.15631C57.2604 1.7592 74.2312 18.7269 73.832 37.9871C73.9749 67.7091 39.0348 84.639 15.8037 66.1138C15.3206 65.732 14.6193 65.8139 14.2374 66.2973C13.8556 66.7804 13.9377 67.4816 14.4209 67.8635C28.9775 79.7855 51.8437 78.4459 64.9146 64.8997C79.6794 50.7335 79.6801 25.24 64.9148 11.0737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0015 66.3839C31.6443 66.3839 25.9117 64.1011 23.7916 62.6621C23.2822 62.3164 22.5887 62.449 22.2428 62.9585C21.897 63.468 22.0296 64.1615 22.5393 64.5073C42.0791 76.2138 68.8094 61.8014 68.6284 37.9866C68.6287 21.0992 54.8894 7.35986 38.0017 7.35986C37.3858 7.35986 36.8866 7.85911 36.8866 8.47493C36.8866 9.09074 37.3858 9.58999 38.0017 9.58999C75.6254 11.0191 75.609 64.9631 38.0015 66.3839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6029 37.9957C20.2703 39.237 20.6256 40.4948 21.5776 41.4466L30.2204 50.0894C31.6506 51.5196 34.0783 51.5227 35.5119 50.0894L48.0843 37.5171C48.5197 37.0816 48.5197 36.3756 48.0843 35.9403C47.6488 35.5048 46.9427 35.5048 46.5074 35.9403L33.935 48.5125C33.3518 49.0956 32.3806 49.0956 31.7974 48.5125L23.1546 39.8697C21.8568 38.572 23.9713 36.4113 25.2921 37.7321L32.0776 44.5176C32.5131 44.9531 33.2191 44.9531 33.6545 44.5176L50.7111 27.461C51.3327 26.8396 52.2049 26.9417 52.8022 27.5391C52.9781 27.715 53.8066 28.6406 52.8486 29.5987L50.6761 31.7711C50.2407 32.2066 50.2407 32.9126 50.6761 33.348C51.1116 33.7834 51.8176 33.7834 52.253 33.348L54.4254 31.1755C57.795 27.6794 52.6233 22.5498 49.1341 25.884L32.8659 42.1521L26.8688 36.1549C24.8135 34.1 21.3315 35.2763 20.6029 37.9957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3921 8.28076C28.9571 8.28076 28.9547 10.5109 30.3921 10.5109C31.8271 10.5109 31.8295 8.28076 30.3921 8.28076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2515 11.2246C21.8165 11.2246 21.8141 13.4547 23.2515 13.4547C24.6865 13.4547 24.6889 11.2246 23.2515 11.2246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1162 18.1461C18.5512 18.1461 18.5536 15.916 17.1162 15.916C15.6812 15.916 15.6788 18.1461 17.1162 18.1461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4038 22.0356C10.9688 22.0356 10.9664 24.2658 12.4038 24.2658C13.8388 24.2658 13.8412 22.0356 12.4038 22.0356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43604 29.1665C8.00103 29.1665 7.99865 31.3966 9.43604 31.3966C10.871 31.3966 10.8734 29.1665 9.43604 29.1665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41553 36.8223C6.98052 36.8223 6.97814 39.0524 8.41553 39.0524C9.85054 39.0524 9.85292 36.8223 8.41553 36.8223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41065 46.7116C10.8457 46.7116 10.848 44.4814 9.41065 44.4814C7.97564 44.4814 7.97326 46.7116 9.41065 46.7116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3545 51.6221C10.9195 51.6221 10.9171 53.8522 12.3545 53.8522C13.7894 53.8522 13.7917 51.6221 12.3545 51.6221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0458 59.9874C18.4808 59.9874 18.4832 57.7573 17.0458 57.7573C15.6109 57.7573 15.6085 59.9874 17.0458 59.9874Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_11491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.9dac71d5ba9217cdaafae9faffd87969.svg";
export { ForwardRef as ReactComponent };